"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditButton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function EditButton(_ref) {
  let {
    context,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Edit ".concat(context)
  }, /*#__PURE__*/_react.default.createElement(StyledIconButton, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Edit.default, {
    fontSize: "inherit"
  })));
}
const StyledIconButton = (0, _styledComponents.default)(_IconButton.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), props => props.theme.font.baseSize);
EditButton.propTypes = {
  context: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};